import { IQueryParams } from '@/types'

const buildQueryParam = (queryObj = {}, prefix = '', suffix = '') => {
  return Object.entries(queryObj)
    .filter(([_, value]) => value != null) // filter out null/undefined values
    .map(([key, value]) => {
      const encodedValue = Array.isArray(value) ? value.join(',') : String(value)
      let filterKey = key

      if (key === 'asc') {
        filterKey = 'Asc'
      } else if (key === 'desc') {
        filterKey = 'Desc'
      }

      return `${encodeURIComponent(prefix + filterKey + suffix)}=${encodeURIComponent(encodedValue)}`
    })
}

export const buildQueryString = (queryParamsObj: IQueryParams) => {

  // Build each query section separately
  const inclusiveFilters = buildQueryParam(queryParamsObj?.filters?.inclusive, 'filterBy-')
  const exclusiveFilters = buildQueryParam(queryParamsObj?.filters?.exclusive, 'filterBy-', '-and')
  const params = buildQueryParam(queryParamsObj?.params)
  const pagination = buildQueryParam(queryParamsObj?.pagination)
  const sorts = buildQueryParam(queryParamsObj?.sorts, 'sortBy')

  // Combine all query parameters into a single array
  const allParams = [...sorts, ...inclusiveFilters, ...exclusiveFilters, ...params, ...pagination]

  // Join the array into a query string
  return allParams.length ? `${allParams.join('&')}` : ''
}